interface def {
  this: string | Record<string, any>
}

class Global_follow {
  constructor(public $: any) {
    this.$ = $
  }
  main() {
    const _that = this.$
    const followarea = _that('.follow_article')
    const global_header = _that('#global-header')
    const global_header_offset: number | any = Math.floor(
      global_header.offset().top
    )
    const global_header_height = global_header.innerHeight()
    const followflug = true

    followarea.hide()
    let timer: any = null
    let obj: def
    _that(window).on('scroll', function(): void {
      clearTimeout(timer)

      timer = setTimeout(function(this: def): void {
        if (followflug) {
          obj = this
          if (
            _that(obj).scrollTop() >=
            Math.abs(global_header_offset - global_header_height)
          ) {
            followarea.fadeIn()
          } else {
            followarea.fadeOut()
          }
        }
      }, 100)
    })
  }
}
export default Global_follow
